import React from 'react';
import { Asset } from '../types/asset/asset';

export interface AssetContextProps {
  assets: Map<string, Asset>;
  setAssets: (asset: Map<string, Asset>) => void;
  assetsLoading: boolean;
}

const defaultContext: AssetContextProps = {
  assets: new Map(),
  setAssets: () => {},
  assetsLoading: false,
};

export const AssetContext = React.createContext<AssetContextProps>(defaultContext);
